'use client';

import { Typography } from '@workspace/ui/common/Typography/Typography';
import { AppImage } from '@/app/common/Image/AppImage';
import { CardLinkButton } from '../ProductSlideshow';
import { CardWrapper } from './ui';
import { sanityImageSrc } from '@/sanity/lib/image';
import { ProductCarouselSlide } from './product-carousel.types';

/**
 * Copy of VariantCard component.
 */
export function ProductCarouselCard({
  hyperlinkLabel,
  productRef,
  productDescription,
  productThumbnail,
}: ProductCarouselSlide) {
  const thumbnailAlt =
    productThumbnail?.bynderImage?.alt || productThumbnail?.alt || `${productRef?.name || 'Product'} thumbnail`;

  return (
    <CardWrapper href={productRef?.productURL}>
      <div
        className={
          'relative flex flex-row items-stretch rounded-md md:rounded-lg border group border-secondary-50 bg-white md:p-0 h-38.75 md:h-53.75 md:gap-md gap-3'
        }
      >
        <div className="relative overflow-hidden shrink-0 w-28 md:w-46.75 h-38.25 md:h-53.25 rounded-l-md md:rounded-l-lg">
          {productThumbnail?.url ? (
            <AppImage
              src={sanityImageSrc(productThumbnail, {
                width: 374,
                height: 426,
              })}
              alt={thumbnailAlt}
              className="rounded-l-md md:rounded-l-lg object-cover md:h-53.75 h-38.75 "
              fill
              priority={false}
            />
          ) : (
            <div className="w-full h-full bg-secondary-200 rounded-l-md md:rounded-l-lg" />
          )}
        </div>

        <div className="flex flex-col justify-between overflow-hidden w-full h-38.75 md:h-53.75 md:gap-lg gap-sm md:pr-lg pr-3 py-xs md:py-sm">
          <div className="min-h-0">
            <Typography
              variant="h4"
              className="!font-bold mb-3xs md:mb-2xs max-sm:font-normal break-words line-clamp-2"
              styleVariant="h6"
            >
              {productRef?.name}
            </Typography>

            {productDescription && (
              <Typography
                variant="bodySm"
                className="max-sm:!text-xs font-openSans text-zinc-600 md:!text-sm !line-clamp-3"
              >
                {productDescription}
              </Typography>
            )}
          </div>

          {hyperlinkLabel && (
            <div className="flex items-center justify-end ">
              <CardLinkButton className="text-sm md:text-base">{hyperlinkLabel}</CardLinkButton>
            </div>
          )}
        </div>
      </div>
    </CardWrapper>
  );
}
